import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import "./hm-theme.css";

const AddDoctors = ({ isOpen, onRequestClose, companyId }) => {
  const navigate = useNavigate();
  const url = "/api/createAccount";
  const token = JSON.parse(localStorage.getItem("data")).token;

  const [doctorDetails, setDoctorDetails] = useState({
    username: "",
    role: "ROLE_DOCTOR",
    doctorName: "",
    phoneNumber: "",
    gender: "",
    dob: "",
    adharNumber: "",
    companyId: companyId,
    email: "",
    address: "",
    pan: "",
    city: "",
    pincode: "",
    state: "",
    sendNotification: false,
    locationId: "",
    doctorProfileImage: {
      image: null,
      imageMeta: "",
    }
  });
  const [loading, setLoading] = useState(false);
  const [genderList, setGenderList] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const genderRes = await axios.get(`/api/gender`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setGenderList(genderRes.data);

        const locRes = await axios.get(`/api/geolocation/companyId=${companyId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLocations(locRes.data);
      } catch (error) {
        console.error(error);
      }
    };
    if (isOpen) fetchData();
  }, [isOpen, companyId, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const emailCheckResponse = await axios.get(`/api/accounts/getByEmail=${doctorDetails.email}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (emailCheckResponse.data) {
        toast.error("Email already exists.");
        setLoading(false);
        return;
      }
    } catch (error) {
      handleError(error);
      setLoading(false);
      return;
    }

    axios.post(url, {
      username: doctorDetails.email,
      role: "ROLE_DOCTOR",
      doctorDetails: {
        doctorName: doctorDetails.doctorName,
        phoneNumber: doctorDetails.phoneNumber,
        gender: doctorDetails.gender,
        dob: doctorDetails.dob,
        adharNumber: doctorDetails.adharNumber,
        companyId: companyId,
        email: doctorDetails.email,
        address: doctorDetails.address,
        pan: doctorDetails.pan,
        city: doctorDetails.city,
        pincode: doctorDetails.pincode,
        state: doctorDetails.state,
        sendNotification: doctorDetails.sendNotification,
        locationId: doctorDetails.locationId,
        doctorProfileImage: doctorDetails.doctorProfileImage
      }
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      setLoading(false);
      onRequestClose();
      toast.success("Doctor account created successfully. Password sent to their email.");
    }).catch((error) => {
      setLoading(false);
      handleError(error);
    });
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const [metadata, content] = reader.result.split(",");
        resolve({ metadata, content });
      };
      reader.onerror = (error) => reject(error);
    });
  }

  const handleImageChange = async (event) => {
    if (event.target.files && event.target.files[0]) {
      const convertedImage = await getBase64FromFile(event.target.files[0]);
      setDoctorDetails((prevState) => ({
        ...prevState,
        doctorProfileImage: {
          imageMeta: convertedImage.metadata,
          image: convertedImage.content,
        },
      }));
    }
  };

  function rhandle(e) {
    const { id, value } = e.target;
    setDoctorDetails((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">medical_services</i>
          Create Doctor Profile
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          {/* Avatar Upload */}
          <div className="d-flex flex-column align-items-center mb-4">
            <div
              className="position-relative mb-2"
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                overflow: "hidden",
                border: "3px solid #2cb6e9",
                background: "#f1f5f9"
              }}
            >
              {doctorDetails.doctorProfileImage?.image ? (
                <img
                  src={`${doctorDetails.doctorProfileImage.imageMeta},${doctorDetails.doctorProfileImage.image}`}
                  alt="Doctor Profile"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <div className="w-100 h-100 d-flex align-items-center justify-content-center text-muted">
                  <i className="material-icons" style={{ fontSize: "3rem" }}>person</i>
                </div>
              )}
            </div>
            <label className="btn btn-sm btn-outline-primary rounded-pill px-3">
              <i className="material-icons" style={{ fontSize: "0.9rem", verticalAlign: "middle" }}>photo_camera</i> Upload Photo
              <input type="file" onChange={handleImageChange} accept="image/*" style={{ display: "none" }} />
            </label>
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label htmlFor="doctorName" className="form-label small fw-semibold">Doctor Name <span className="text-danger">*</span></label>
              <input className="form-control" id="doctorName" type="text" placeholder="Dr. Full Name" value={doctorDetails.doctorName} onChange={rhandle} required />
            </div>
            <div className="col-md-6">
              <label htmlFor="email" className="form-label small fw-semibold">Email ID <span className="text-danger">*</span></label>
              <input className="form-control" id="email" type="email" placeholder="doctor@example.com" value={doctorDetails.email} onChange={rhandle} required />
            </div>
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label htmlFor="phoneNumber" className="form-label small fw-semibold">Phone Number <span className="text-danger">*</span></label>
              <input className="form-control" id="phoneNumber" type="text" placeholder="+91 XXXXXXXXXX" value={doctorDetails.phoneNumber} onChange={rhandle} required />
            </div>
            <div className="col-md-6">
              <label htmlFor="gender" className="form-label small fw-semibold">Gender <span className="text-danger">*</span></label>
              <select className="form-select" id="gender" value={doctorDetails.gender} onChange={rhandle} required>
                <option value="">Select Gender</option>
                {genderList.map((g) => (
                  <option key={g.id} value={g.gender}>{g.gender}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label htmlFor="dob" className="form-label small fw-semibold">Date of Birth <span className="text-danger">*</span></label>
              <input className="form-control" id="dob" type="date" value={doctorDetails.dob} onChange={rhandle} required />
            </div>
            <div className="col-md-6">
              <label htmlFor="locationId" className="form-label small fw-semibold">Location <span className="text-danger">*</span></label>
              <select className="form-select" id="locationId" value={doctorDetails.locationId} onChange={rhandle} required>
                <option value="">Select Location</option>
                {locations.map((loc) => (
                  <option key={loc.id} value={loc.id}>{loc.location}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label htmlFor="pan" className="form-label small fw-semibold">PAN <span className="text-danger">*</span></label>
              <input className="form-control" id="pan" type="text" placeholder="PAN Number" value={doctorDetails.pan} onChange={rhandle} required />
            </div>
            <div className="col-md-6">
              <label htmlFor="adharNumber" className="form-label small fw-semibold">Aadhaar Number <span className="text-danger">*</span></label>
              <input className="form-control" id="adharNumber" type="text" placeholder="Aadhaar Number" value={doctorDetails.adharNumber} onChange={rhandle} required />
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="address" className="form-label small fw-semibold">Address <span className="text-danger">*</span></label>
            <textarea className="form-control" id="address" rows="2" placeholder="Street Address" value={doctorDetails.address} onChange={rhandle} required />
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-4">
              <label htmlFor="city" className="form-label small fw-semibold">City <span className="text-danger">*</span></label>
              <input className="form-control" id="city" type="text" placeholder="City" value={doctorDetails.city} onChange={rhandle} required />
            </div>
            <div className="col-md-4">
              <label htmlFor="pincode" className="form-label small fw-semibold">Pincode <span className="text-danger">*</span></label>
              <input className="form-control" id="pincode" type="text" placeholder="Pincode" value={doctorDetails.pincode} onChange={rhandle} required />
            </div>
            <div className="col-md-4">
              <label htmlFor="state" className="form-label small fw-semibold">State <span className="text-danger">*</span></label>
              <input className="form-control" id="state" type="text" placeholder="State" value={doctorDetails.state} onChange={rhandle} required />
            </div>
          </div>

          <div className="form-check mb-4">
            <input
              className="form-check-input"
              type="checkbox"
              id="sendNotification"
              checked={doctorDetails.sendNotification}
              onChange={(e) => setDoctorDetails((prev) => ({ ...prev, sendNotification: e.target.checked }))}
            />
            <label className="form-check-label small fw-semibold" htmlFor="sendNotification">
              Send notification email with login credentials
            </label>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>person_add</i>
              Save Doctor
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddDoctors;
